import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async'

import { getQueryParamsFromHash, parsePermittedQueryParams } from '@domain-group/javascript-utils'

import { Box, Button, Columns } from '@domain-group/suit-theme'

import PageHeader from '@components/PageHeader'

import generateTabBarItems from '../../utils/generateTabBarItems'

const PageLayout = (props) => {
  const { activeTabBarItemKey, children, entityPayload } = props

  const {
    brandGroup,
    urls: { brandGroupsIndexUrl },
  } = entityPayload

  const { redirect } = parsePermittedQueryParams(getQueryParamsFromHash(), ['redirect'])

  return (
    <>
      <Helmet>
        <title>Brand Groups | Realhub</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <Button
            as="a"
            buttonStyle="secondaryUtility"
            href={redirect || brandGroupsIndexUrl}
            size="medium"
            width="auto"
          >
            Back
          </Button>
        )}
        activeTabBarItemKey={activeTabBarItemKey}
        tabBarItems={generateTabBarItems(brandGroup)}
        title="Edit Brand Group"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          {children}
        </Columns>
      </Box>
    </>
  )
}

PageLayout.propTypes = {
  activeTabBarItemKey: PropTypes.string,
  children: PropTypes.node.isRequired,
  entityPayload: PropTypes.shape({
    brandGroup: PropTypes.object.isRequired,
    urls: PropTypes.shape({
      brandGroupsIndexUrl: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
}

export default PageLayout
